import { RelevantContentController as controller } from './relevant-content.controller';
import template from './relevant-content.html';
import './relevant-content.global.css';

export const RelevantContentComponent = {
  bindings: {
    title: '@',
    step: '@',
  },
  controller,
  template,
};
